import { IconProps } from './types';

export function Flag({ size, ...props }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6.25 26.25V5M6.25 5C11.25 1.875 16.25 8.125 22.5 5V16.25C16.25 19.375 11.25 13.125 6.25 16.25"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
